module.exports = __webpack_public_path__ + "img/luigi-min.33b3afc7.png";